import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SuccessComponent } from '../abp-post-create/success/success.component';
import { ABPService } from 'src/app/abp-management/abp.service';

@Component({
  selector: 'app-abp-post-delete',
  templateUrl: './abp-post-delete.component.html',
  styleUrls: ['./abp-post-delete.component.scss'],
})
export class AbpPostDeleteComponent implements OnInit {
  constructor(
    public ref: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dialogService: DialogService,
    private abpService: ABPService
  ) {}

  ngOnInit(): void {}

  deleteItem() {
    const tempObj = { ...this.dynamicDialogConfig.data, _status: 'DP' };
    this.dialogService.open(SuccessComponent, {
      width: '20%',
    });
    this.abpService.updateLocalPost(tempObj);
    this.ref.close();
  }

  unpublishItem() {
    const tempObj = { ...this.dynamicDialogConfig.data, _status: 'UP' };
    this.dialogService.open(SuccessComponent, {
      width: '20%',
    });
    this.abpService.updateLocalPost(tempObj);
    this.ref.close();
  }
}
